module.exports = __webpack_public_path__ + "files/207407325f0ab25a03bb84c5dbea5a8c.png";